module.exports = __webpack_public_path__ + "static/the-journey-within-732e73930ae7de87c95a1ea77f14c667.jpg";